"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalModalDiv = exports.AuthUserDiv = exports.AuthBoxDiv = exports.LogoDiv = exports.HeaderInputWrapDiv = exports.HeaderWrapperDiv = exports.RecoilUsedHeaderDiv = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.RecoilUsedHeaderDiv = styled_components_1.default.div `
  display: flex;
  justify-content: center;

  width: 100%;
  height: 74px;
  max-height: 74px;

  border-bottom: 1px solid #eaeaea;
  background-color: white;

  .focus {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
`;
// 426
exports.HeaderWrapperDiv = styled_components_1.default.div `
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: ${(props) => {
    if (props.full_width === "1070px") {
        return "282px";
    }
    if (props.full_width === "940px") {
        return "232px";
    }
    return "437px";
}}
    ${(props) => {
    if (props.full_width === "1070px") {
        return "506px";
    }
    if (props.full_width === "940px") {
        return "506px";
    }
    if (props.full_width === "100%" && props.isPointed) {
        return "1fr";
    }
    return "720px";
}}
    auto;
  align-items: center;

  width: ${(props) => props.full_width};
  height: 100%;

  padding-left: ${(props) => (props.input_width === "720px" ? "14px" : "0")};
  padding-right: ${(props) => (props.input_width === "720px" ? "24px" : "0")};

  box-sizing: border-box;
`;
exports.HeaderInputWrapDiv = styled_components_1.default.div `
  /* padding-left: 123.8px; */
  /* padding-right: 20px; */

  min-width: 430px;
`;
exports.LogoDiv = styled_components_1.default.div `
  display: flex;
  align-items: center;

  max-width: 168.2px;
  height: 100%;

  /* margin-right: 123.8px; */
  padding: 0 10px;

  .Diningcode__Logo {
    width: 148.2px;
    height: 28.7px;
  }
`;
exports.AuthBoxDiv = styled_components_1.default.div `
  display: inline-flex;
  justify-content: flex-end;
  gap: 30px;

  box-sizing: border-box;

  width: 100%;
  height: 20px;
  padding-left: 24px;

  white-space: nowrap;

  a {
    height: 20px;
    line-height: 20px;
    font-size: 0.875rem;
    color: #202020;
  }

  .Auth__Login {
    width: 2.415rem;
  }

  .Auth__Register {
    width: 3.2206rem;
  }
`;
exports.AuthUserDiv = styled_components_1.default.div `
  position: relative;
  justify-self: flex-end;

  display: flex;
  justify-content: flex-end;
  align-items: center;

  width: fit-content;
  min-width: 163px;

  .Auth__User__Button {
    display: flex;
    align-items: center;
    gap: 10px;

    white-space: nowrap;
    font-size: 0.875rem;
    color: #202020;
  }

  .User__Name {
    position: relative;
    font-weight: bold;
  }

  .Auth__User__Button__img {
    position: relative;
    top: 2px;

    width: 10px;
    height: 5.7px;

    transform: rotate(0.5turn);
  }

  .Authed__User {
    display: flex;
  }
`;
exports.PersonalModalDiv = styled_components_1.default.div `
  position: absolute;
  z-index: 1002;
  top: 50px;
  right: 0;

  display: flex;
  flex-direction: column;
  justify-content: center;

  width: 149px;
  height: 72px;

  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);

  a {
    display: flex;
    justify-content: flex-start;

    width: 100%;
    height: 34px;

    padding: 8px 0 8px 16px;

    font-size: 0.875rem;
    letter-spacing: -0.0437rem;
    color: #505050;
  }
  a:hover {
    background-color: #f5f5f5;
  }
`;
